export enum RoundingType {
  Standard = 0,
  RoundingUp = 1,
  RoundingDown = 2,
}
export enum ShippingCostReducedKind {
  NoReduced = 1,
  ShippingCost = 2,
  CourierShippingCost = 3,
}

export enum Currency {
  Rial = 1,
  Toman = 2,
}

export enum TypeOfDocument {
  accumulative = 1,
  Separation = 2,
}

export enum InvDailyBalanceInhibitorEnum {
  "بازدارنده" = 1,
  "هشداردهنده" = 2,
}

export enum InvDailyBalanceInhibitorValueEnum {
  Inhibitor = 1,
  warning = 2,
}
